import { render } from "./fournisseur.vue?vue&type=template&id=985a1618&scoped=true"
import script from "./fournisseur.vue?vue&type=script&lang=js"
export * from "./fournisseur.vue?vue&type=script&lang=js"

import "./fournisseur.vue?vue&type=style&index=0&id=985a1618&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985a1618"]])

export default __exports__